export default "__VITE_ASSET__DGVYZ6Y4__"